import React, { useEffect, useState } from "react";
import { UnconfirmedStage } from "@greeter-venue/components/ConfirmSwiper/UnconfirmedStage";
import { LoadingStage } from "@greeter-venue/components/ConfirmSwiper/LoadingStage";
import { DoneStage } from "@greeter-venue/components/ConfirmSwiper/DoneStage";

import css from "./RejectSwiper.module.scss";
import { doNothing, classNames } from "@greeter/util";

export type RejectStage = "unrejected" | "loading" | "done";

export type RejectSwiperProps = {
  stage: RejectStage;
  onReject?: () => void;
  disabled?: boolean;
  className?: string;
};

function renderStage(stage: RejectStage, onReject: () => void) {
  switch (stage) {
    case "unrejected":
      return (
        <UnconfirmedStage
          onAccept={onReject}
          text={"Afvis"}
          {...classNames(css.UnconfirmedStage)}
        />
      );
    case "loading":
      return <LoadingStage text="Afvis" className={css.LoadingStage} />;
    case "done":
      return <DoneStage text={"Ordren er afvist"} className={css.DoneStage} />;
  }
}

export const RejectSwiper: React.FC<RejectSwiperProps> = ({
  stage,
  onReject = doNothing,
  className,
  disabled = false,
}) => {
  return (
    <div
      className={
        disabled ? classNames(className, css.Disabled).className : className
      }
    >
      {renderStage(stage, onReject)}
    </div>
  );
};
